import { useEffect, useState } from 'react';

const useFacebookSDK = (appId) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    let scriptElement = null;

    if (window.FB) {
      setIsInitialized(true);
      return;
    }

    const loadFacebookSDK = () => {
      if (document.getElementById('facebook-jssdk')) return;

      scriptElement = document.createElement('script');
      Object.assign(scriptElement, {
        id: 'facebook-jssdk',
        src: 'https://connect.facebook.net/en_US/sdk.js',
        async: true,
        defer: true,
      });

      scriptElement.onerror = () => {
        if (isMounted) {
          setError('Failed to load Facebook SDK');
        }
      };

      document.body.appendChild(scriptElement);
    };

    const initializeFacebookSDK = () => {
      window.fbAsyncInit = () => {
        try {
          window.FB.init({
            appId,
            cookie: true,
            xfbml: true,
            version: 'v21.0',
          });
          isMounted && setIsInitialized(true);
        } catch (err) {
          isMounted && setError(err.message);
        }
      };
    };

    loadFacebookSDK();
    initializeFacebookSDK();

    return () => {
      isMounted = false;
      if (scriptElement) {
        scriptElement.remove();
      }
    };
  }, [appId]);

  return { isInitialized, error };
};

export default useFacebookSDK;
